<template>
  <div>
    <gmap-map id="mapMain"
              ref="mapMain"
              :center="center"
              :zoom="zoom"
              @click="getMapPoint($event)"
              @center_changed="updateCenter($event)"
              @dragend="dragend($event)"
              style="width: 100%; height: 90vh;">

      <gmap-info-window v-for="project in $parent.filteredRows"
                        ref="infoImgProject"
                        :position="project.Location"
                        :options="infoMarkerOptions"
                        :zIndex="project.zIndex"
                        :opened="isOpen"
                        :id="'gmapProject' + project.userId"
                        @domready="projectReady">
        <div :id="'arrow' + project.userId" class="divProjectArrow" :style="{ 'background-color': $parent.getStatusColor(project.StatusKey) }"></div>

        
        <div class="divMarker" @mouseover="selectProject(project)" @mouseout="resetProject(project)" @click="$parent.edit(project)">
          <span class="divPercent" :style="{ 'z-index': project.zIndex + 5 }">{{project.Percent}}%</span>
          <img :id="'project' + project['.key']" src="../assets/helmetSmall.png" class="imgProject" :style="{ 'border-color': $parent.getStatusColor(project.StatusKey), 'z-index': project.zIndex }" />
        </div>
        
        
      </gmap-info-window>

      <gmap-info-window ref="infoProject"
                        :position="selectedProject.Location"
                        :options="infoOptions"
                        :zIndex="selectedProject.zIndex"
                        :opened="isOpenInfo">
        <div id="projectInfo" class="infoWindow">
          <div style="color: #CC2636;font-size:14px;">
            <img class="divIcon" src="../assets/icon.png"/>
            <b>{{selectedProject.Name}}</b>
          </div>
          <div>
            <div class="mapDivColor" :style="{ 'background-color': $parent.getStatusColor(selectedProject.StatusKey) }"></div>
            <b>{{$parent.getStatusName(selectedProject.StatusKey)}}</b>
          </div>
          <span>{{selectedProject.City}}, {{selectedProject.Address}}</span>
          <span>{{selectedProject.Info}}</span>
          <img v-if="selectedProject.Images" class="imgProjectMap" :src="selectedProject.Images[0]" />
        </div>
      </gmap-info-window>

      <gmap-marker v-if="$parent.popup.isVisible" :zIndex="5200" :position="marker" :draggable="false"></gmap-marker>

      </gmap-map>
    </div>
</template>

<script>

  import imgUser from '../assets/user.png';

  export default {
    name: 'DataMap',
    data() {
      return {
        txtSearch: '',
        center: { lat: 32.699635, lng: 35.303546 },
        zoom: 10,
        marker: { lat: 32.699635, lng: 35.303546 },
        infoOptions: {
          pixelOffset: {
            width: 120,
            height: 0,
          }
        },
        infoMarkerOptions: {
          width: 50,
          height: 50,
          pixelOffset: {
            width: 0,
            height: 35
          }
        },
        isOpen: true,
        isOpenInfo: false,
        selectedProject: {
          zIndex: 5000,
          '.key': '',
          Name: '',
          City: '',
          Address: '',
          Location: { lat: 0, lng: 0 },
          Info: '',
          StatusKey: 0,
          UserKey: '',
          Active: true,
          Images: []
        },
      }
    },
    created() {
      this.$Log("Vue [DataMap] is created ...");
    },
    ready() {
      this.$Log("Vue [DataMap] is ready ...");
    },
    mounted() {
      this.$Log("Vue [DataMap] is mounted ...");
    },
    updated() {
      this.$Log("Vue [DataTable] is updated ...");
    },
    methods: {
      projectReady() {
        var vm = this;
        vm.$Log("Project Dom is Ready 00000");
      },
      getMapPoint(event) {
        var vm = this;
        //if (vm.$route.path === "/New/") {
        //  this.$root.alert.message = this.$t("pointPolygon");//'Please select point in your polygon!!';
        //  this.$root.alert.isShow = true;
        //}
        vm.marker = { lat: event.latLng.lat(), lng: event.latLng.lng() };

        vm.$parent.addNew(vm.marker);
      },
      updateCenter(event) {
        var vm = this;
        //vm.$UpdateMapCenter(vm, event);
      },
      dragend() {
        var vm = this;
        vm.$Log("Drag end ... ");
        //vm.isDraged = true;
      },
      selectProject(project) {
        project.zIndex = 5300;
        this.selectedProject = {
          zIndex: 5200,
          '.key': project['.key'],
          Name: project.Name,
          City: project.City,
          Address: project.Address,
          Location: project.Location,
          Info: project.Info,
          StatusKey: project.StatusKey,
          UserKey: project.UserKey,
          Active: project.Active,
          Images: project.Images
        };
        this.isOpenInfo = true;

        console.log(JSON.stringify(this.selectedProject))
      },
      resetProject(project) {
        project.zIndex = 5000;
        this.isOpenInfo = false;
        this.selectedProject = {
          zIndex: 5000,
          '.key': '',
          Name: '',
          City: '',
          Address: '',
          Location: { lat: 0, lng: 0 },
          Info: '',
          StatusKey: '',
          UserKey: '',
          Active: true,
          Images: []
        };
      },
    }
  }

</script>
<style>

  div[style="width: 13px; height: 13px; overflow: hidden; position: absolute; opacity: 0.7; right: 12px; top: 10px; z-index: 10000; cursor: pointer;"] {
    display: none !important;
  }

  div[style="position: absolute; left: 0px; top: 0px;"] {
    display: none !important;
  }

  div[style="width: 13px; height: 13px; overflow: hidden; position: absolute; opacity: 0.7; right: 12px; top: 10px; z-index: 10000;"] {
    display: none !important;
  }

  div[style="width: 13px; height: 13px; overflow: hidden; position: absolute; opacity: 0.7; left: 12px; top: 10px; z-index: 10000; cursor: pointer;"] {
    display: none !important;
  }

  .infoWindow {
    direction: ltr;
    text-align: right;
    width: 230px !important;
    /*height: 180px !important;*/
    border: 0.5px solid #CC2636;
    background-color: #fff;
    color: #777;
    font-size: 12px;
    padding: 10px;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    /*overflow: hidden;*/
    /*visibility: hidden;*/
    /*z-index: -99;*/
    /*display: none;*/
    /*position: absolute;*/
  }

    .infoWindow > div {
      color: #777;
      padding: 2px;
      padding-left: 10px;
      display: block;
      text-align: right;
      font-weight: normal;
    }

      .infoWindow > div > img.divIcon {
        width: 18px;
        height: 18px;
        margin-left: 5px;
        float: right;
      }

      .infoWindow > div > div.mapDivColor {
        width: 15px;
        height: 15px;
        border-radius: 3px;
        margin-left: 5px;
        float: right;
      }

    .infoWindow > span {
      color: #777;
      padding: 2px;
      padding-left: 10px;
      display: block;
      text-align: right;
      font-weight: normal;
    }

      .infoWindow > span > b {
        font-weight: bolder;
      }

  infoWindow:before, figure:after {
    content: '';
    position: absolute;
  }

  infoWindow:before {
    right: -50%;
    top: 0;
    background: transparent;
    width: 50px;
    height: 50px;
    border: 1px solid black;
    border-radius: 100%;
    box-shadow: 0 0 0 100em red;
  }

  infoWindow:after {
    left: -1px;
    bottom: 0px;
    height: 50px;
    width: 50px;
    border-top-left-radius: 0;
    border-bottom-left-radius: 5px;
    border-left: 1px solid black;
    border-bottom: 1px solid black;
  }

  .showInfo {
    display: block;
    visibility: visible;
    z-index: 1;
  }

  .topIndex {
    z-index: 5100;
  }

  .divMarker {
    position: relative;
    cursor: pointer;
  }

  .imgProject {
    width: 50px;
    height: 50px;
    /*border: 3px solid #CC2636;*/
    border-style: solid;
    border-width: 3px;
    border-radius: 100%;
    cursor: pointer;
    position: relative;
  }

  .divPercent {
    position: absolute;
    font-weight: bold;
    width: 30px;
    font-size: 12px;
    /*padding-top: 27px;*/
    margin-top: 27px;
    margin-right: 10px;
  }

  .divProjectArrow {
    width: 10px;
    height: 10px;
    /*background-color: #CC2636;*/
    -ms-transform: rotate(45deg); /* IE 9 */
    -webkit-transform: rotate(45deg); /* Safari */
    transform: rotate(45deg);
    position: absolute;
    left: 32px;
    top: 44px;
  }

  .projectFont {
    font-family: "Segoe UI",Arial,sans-serif !important;
  }

  .imgProjectMap {
    width: 100%;
    max-height: 200px;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
  }

</style>



// WEBPACK FOOTER //
// DataMap.vue?43c26950